import React from "react";
import {
	ContainerWithBG,
	RoundedContainer,
} from "./rounded-container-with-bg.styles";

const RoundedContainerWithBG = ({
	children,
	padding,
	margin,
	backgroundImageUrl = "https://firebasestorage.googleapis.com/v0/b/polish-1afa6.appspot.com/o/Wallpapers%2Fpalac%20kultury.jpg?alt=media&token=1ba04b39-ce92-480a-a64e-0c3e7121285f",
}) => (
	<ContainerWithBG backgroundImageUrl={backgroundImageUrl}>
		<RoundedContainer
			id={"rounded-container"}
			$padding={padding}
			{...{ $margin: margin }}
		>
			{children}
		</RoundedContainer>
	</ContainerWithBG>
);

export default RoundedContainerWithBG;
